import styled from "styled-components";

export const Content = styled.div`
  width: 90%;
  max-width: 1400px;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column;
  margin: 48px auto 17.5%;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 32px;
  gap: 8px;

  > h2 {
    font-size: 32px;
    font-weight: bold;
    color: #666666;
    margin: 0;
  }

  @media (max-width: 767px) {
    > h2 {
      font-size: 22px;
    }
  }
`;

export const FilterLabel = styled.p`
  margin: 0;
  color: #888888;
  font-size: 15px;
  font-weight: 500;
  max-width: 640px;
  line-height: 1.4;
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(160px, 240px));
  gap: 16px;
  justify-content: center;
  margin: 0 auto 32px;
  width: 100%;

  @media (max-width: 1023px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-width: 520px;
  }

  @media (max-width: 479px) {
    gap: 12px;

    /* Period on its own row, the three counts below it. */
    > :first-child {
      grid-column: 1 / -1;
    }
  }
`;

export const PendingNote = styled.p`
  margin: -16px auto 24px;
  color: #888888;
  font-size: 14px;
  text-align: center;
`;

export const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

export const SummaryLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #dd6435;
  color: #fff;
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  > svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
`;

export const SummaryValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  color: #666666;
  font-size: 16px;
  font-weight: 600;
  padding: 16px;
  text-align: center;
  min-height: 56px;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow: auto;
  border-radius: 4px;
`;

export const ReportTable = styled.table`
  border-spacing: 0 10px;
  border-collapse: separate;
  width: 100%;
  min-width: 1100px;

  thead th {
    background: #6ea5ff;
    text-align: start;
    color: #ffffff;
    font-weight: 500;
    padding: 14px 16px;
    white-space: nowrap;

    &:first-child {
      border-radius: 4px 0 0 4px;
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }

  tbody td {
    padding: 14px 16px;
    background: #f9f9f9;
    color: #666666;
    vertical-align: middle;

    &:first-child {
      border-radius: 4px 0 0 4px;
      font-weight: 500;
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }

  tbody tr:hover td {
    background: #f1f5fb;
  }

  @media (max-width: 767px) {
    display: block;
    width: 100%;
  }
`;

export const NowrapCell = styled.td`
  white-space: nowrap;
`;

export const VideoBadge = styled.span<{ $isVideo: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ $isVideo }) => ($isVideo ? "#2f6fed" : "#666666")};
  background: ${({ $isVideo }) => ($isVideo ? "#e8f0ff" : "#eeeeee")};
`;

const OUTCOME_COLORS = {
  completed: { color: "#1f7a4d", background: "#e3f5ec" },
  no_show: { color: "#c0392b", background: "#fdecea" },
  none: { color: "#888888", background: "#eeeeee" },
};

export const OutcomeBadge = styled.span<{
  $outcome: "completed" | "no_show" | null;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  color: ${({ $outcome }) => OUTCOME_COLORS[$outcome ?? "none"].color};
  background: ${({ $outcome }) => OUTCOME_COLORS[$outcome ?? "none"].background};
`;

export const EmptyState = styled.div`
  width: 100%;
  max-width: 520px;
  margin: 8px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  padding: 48px 24px;
  background: #f9f9f9;
  border-radius: 4px;
  border: 1px dashed #d0d5dd;

  > svg {
    color: #6ea5ff;
    margin-bottom: 4px;
    width: 40px;
    height: 40px;
  }

  > strong {
    color: #666666;
    font-size: 18px;
    font-weight: 600;
  }

  > p {
    margin: 0;
    color: #888888;
    font-size: 14px;
    line-height: 1.5;
    max-width: 360px;
  }
`;
